import React from 'react';
import { ApiGenericPage } from '@kevlarcon/pages';
import SiteAdminChrome from './SiteAdminChrome';

/**
 * The public tenant site. Framed by the tenant header (menu-driven) and footer.
 * Every path, including the root, goes through @kevlarcon/pages' ApiGenericPage —
 * the home page is an ordinary CMS Page (slug '') built from custom-component
 * Sections (see frontend/src/site/customComponents.tsx and
 * docs/plans/site-content-architecture.md), not a hardcoded component.
 *
 * Org admins get the CMS toolbar and editors via SiteAdminChrome — always
 * present, not gated behind an "enter edit mode" step. Anonymous visitors
 * just see the rendered page.
 */
const TenantSite: React.FC = () => (
  <SiteAdminChrome>
    <ApiGenericPage />
  </SiteAdminChrome>
);

export default TenantSite;
